import { post } from '@alltrails/shared/api';

// API under app/controllers/my

type ToggleSubscriptionStatusResponse = {};

export async function toggleSubscriptionStatus() {
  return post<ToggleSubscriptionStatusResponse>('/my/profile/toggle_subscription_status');
}
